window.CandidateAPI = new (function () {

    var self = this;
    var _protected = BaseAPI.call(self);

    self.candidateBrandServicesCheck = function (serviceCode, onlyHired, internalJobsEnabled) {
        var deferred = $q.defer();
        var params = {
            only_hired: onlyHired,
            internal_jobs_enabled: internalJobsEnabled
        }

        if (serviceCode) {
            params['service_codes'] = serviceCode;
        }
        _protected.request('candidates/brands', 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res.data.data);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    }

    self.searchInternalJobs = function (params) {
        var deferred = $q.defer();

        _protected.request('candidates/jobs/search', 'POST', params)
            .then(function (res) {
                if (res && res.data && res.data.data && res.data.status_code === 200) {
                    deferred.resolve(res);
                }
                else {
                    deferred.reject(res);
                }
            }, function (err) {
                deferred.reject(err);
            });
        return deferred.promise;
    }
});